import URL from "./url";
import request from "@/utils/request";
import qs from 'qs'
const api = {};

for (const key in URL) {
  if (URL.hasOwnProperty(key)) {
    let _obj = URL[key];
    api[key] = function(data) {
      if (_obj.method === "get") {
        const requestParams = {
          url: _obj.url,
          method: _obj.method,
          params: data
        }
        if (_obj.baseURL) {
          Object.assign(requestParams, {
            baseURL: _obj.baseURL
          })
        }
        return request({ ... requestParams })
      } else {
        data = JSON.parse(JSON.stringify(data))
        for( const i in data ){
          if(Array.isArray(data[i])){
            data[i] = JSON.stringify(data[i])
          }
        }
        const requestParams = {
          url: _obj.url,
          method: _obj.method,
          data : qs.stringify(data),
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
        if (_obj.baseURL) {
          Object.assign(requestParams, {
            baseURL: _obj.baseURL
          })
        }
        return request({ ... requestParams })
      }
    };
  }
}
export default api;